<div *ngIf="allPosts" class="page-container">
  <app-cards [cards]="allPosts" [page]="null"></app-cards>
</div>

<div *ngIf="!allPosts|| isLoading" class="page-container page">
  <h2>Vennligst vent mens naturgledepostene lastes. Dette kan ta litt tid.</h2>
</div>
